var React = require('react');
var Shopify = require('./shopify');
var Utils = require('./utils');
var ShippingReturnSeg = require('./collapsable-group');
var ScrollToTop = require('./scroll-to-top');

module.exports = React.createClass({

  mixins: [ ScrollToTop ],

  pendingList: [],
  curBlogName: "",
  segments: [],
  curBlogIndex: 0,

  getInitialState: function() {
    return { segments: [] }
  },

  componentDidMount: function() {

    document.title = "Shipping & Return - Ingledew's Shoes";

    this.scrollToTop('shipping-returns-page');
    Shopify.getSpecialPost("shipping-and-returns", this.postListGot);
    setTimeout(function() { jQuery(window).scroll(); }, 300);
  },

  postListGot: function(post) {
    var post = Utils.reconstructPost(post.content);

    this.pendingList = post.getByTag("p", false);

    if (this.pendingList.length) {
      this.curBlogName = this.pendingList.shift().innerText;
      var postHandle = this.curBlogName.toLowerCase().replace(' ', '-');
      Shopify.getSpecialPost(postHandle, this.blogGot, false);        
    }
  },

  blogGot: function(articles) {
    this.segments.push(<ShippingReturnSeg name={this.curBlogName}
                                          items={articles}
                                          blogIndex={this.curBlogIndex}
                                          noFade={0 == this.curBlogIndex ? true: false}
                                          key={this.segments.length} />);
    this.curBlogIndex++;
    if (this.pendingList.length) {
      this.curBlogName = this.pendingList.shift().innerText;
      var postHandle = this.curBlogName.toLowerCase().replace(' & ', '-');
      postHandle = postHandle.toLowerCase().replace(' ', '-');
      Shopify.getSpecialPost(postHandle, this.blogGot, false);
    } else {
      this.setState({ segments: this.segments });
    }
  },

  render: function() {

    return <main ref="root" id="content" className="container" role="main">
            <div className="row">
                <div className="col-md-8 col-md-offset-2">
                    <p className="lead">- policy -</p>
                    <h1>SHIPPING & RETURNS</h1>
                    {this.state.segments}
                </div>
            </div>
      </main>
  }
});


